import { ArchivedBeneficiariesType } from '../ArchivedBeneficiary/types';

export const filterNeighborApiResponse = (response: any): any => {
  const { data } = response;

  return Object.values(data).map((neighbor: any): any => {
    return {
      key: neighbor.id,
      id: neighbor.id,
      neighbor: {
        id: neighbor.id,
        avatar: neighbor.avatar,
        firstname: neighbor.first_name,
        lastname: neighbor.last_name,
        count: neighbor.count,
        customer_name: neighbor.customer_name,
        address: neighbor.places[0]?.address.formatted_address,
        phone: neighbor.phones[0]?.phone,
        mobile: neighbor.phones[1]?.phone,
        email: neighbor.emails[0]?.email,
      },
    };
  });
};

export const filterArchivedBeneficiariesApiResponse = (
  archivedBeneficiaries: ArchivedBeneficiariesType[]
): any => {
  return Object.values(archivedBeneficiaries).map(
    (archivedBeneficiary: ArchivedBeneficiariesType) => {
      return {
        key: archivedBeneficiary.id,
        id: archivedBeneficiary.id,
        archivedBeneficiary: {
          id: archivedBeneficiary.id,
          name: archivedBeneficiary.name,
          address: archivedBeneficiary.places[0].address.formatted_address,
          resiliationDate: archivedBeneficiary.resiliation_date,
        },
      };
    }
  );
};

export const filterApiResponse = (response: any): any => {
  const { data } = response;

  return Object.values(data).map((neighbor: any): any => {
    return {
      id: neighbor.id,
      neighbor: {
        id: neighbor.id,
        avatar: neighbor.avatar,
        firstname: neighbor.first_name,
        lastname: neighbor.last_name,
      },
    };
  });
};
